export const IconSoundRecordings = ({size = 20, color = "#000"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size + 5} ${size + 15}`} fill="none">
    <path d="M2 13.0833V16.25M6.75 8.33333V21M11.5 11.5V17.8333M16.25 6.75V22.5833M21 2V27.3333M25.75 9.91667V19.4167M30.5 13.0833V16.25" stroke={color} strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)